// src/config/basket.js
// DEFAULT_BASKET: cart-page UI copy (structural; admin-editable via the Cart Copy area).
// DEFAULT_TERMINOLOGY / _CATEGORIES: BLANK-but-valid scaffolds (Slice 1 de-seed, decision C
// "ship empty"). The glossary ships with NO starter terms/categories; Danielle adds them
// via the admin Terminology editor. The SHAPE ({ terms: [], categories: [] }) is the
// structural fallback before /config/terminology is filled.

export const DEFAULT_BASKET = {
    pageTagline: 'Cart',
    pageTitle: 'Your Cart',
    emptyMessage: 'Your cart is empty',
    subtotalLabel: 'Subtotal',
    processingLabel: 'Processing',
    processingValue: 'Included',
    totalLabel: 'Total',
    checkoutButton: 'Proceed to Checkout'
};

export const DEFAULT_TERMINOLOGY_CATEGORIES = [];

export const DEFAULT_TERMINOLOGY = [];
